var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { ref: "table", staticClass: "table" }, [
    _c("thead", [
      _c(
        "tr",
        _vm._l(_vm.headColumns, function(col, idx) {
          return _c("th", { key: idx, style: col.style }, [
            _c("span", [
              _vm._v("\n          " + _vm._s(col.text) + "\n        ")
            ])
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.rows, function(row, idx) {
        return _c(
          "tr",
          {
            key: idx,
            ref: "tr-" + idx,
            refInFor: true,
            on: {
              click: function($event) {
                return _vm.toggle("tr-" + idx)
              }
            }
          },
          _vm._l(row, function(item, itemIdx) {
            return _c("td", { key: itemIdx }, [
              _c("div", { staticClass: "head" }, [
                _c("span", [
                  itemIdx === 0
                    ? _c("i", { staticClass: "fas fa-angle-right" })
                    : _vm._e(),
                  _vm._v(
                    "\n            " + _vm._s(item.head.text) + "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "body" },
                _vm._l(item.body, function(body, bodyIndex) {
                  return _c(
                    "p",
                    {
                      key: bodyIndex,
                      class: "tr-" + idx + "-p-" + bodyIndex + " limit-line",
                      on: {
                        mouseover: function($event) {
                          return _vm.handleMouseover(
                            "tr-" + idx + "-p-" + bodyIndex
                          )
                        },
                        mouseleave: function($event) {
                          return _vm.handleMouseleave(
                            "tr-" + idx + "-p-" + bodyIndex
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(body.text) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ])
          }),
          0
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6baf767c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6baf767c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseTableCollapse.vue
// module id = null
// module chunks = 